export const PRESET_WALLPAPERS = [
    { id: "studio", url: "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1280", label: "Studio" },
    { id: "stage", url: "https://images.unsplash.com/photo-1485579149621-3123dd979885?w=1280", label: "Stage" },
    { id: "neon", url: "https://images.unsplash.com/photo-1496450681664-3df85efbd29f?w=1280", label: "Neon City" },
    { id: "abstract", url: "https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=1280", label: "Abstract" },
];
